var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "layoutTop" }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-10 offset-md-1" }, [
            _c("div", { staticClass: "panel21 panel-default" }, [
              _c("form", [
                _c("div", { staticClass: "form-group row" }, [
                  _c(
                    "label",
                    { staticClass: "col-5 col-sm-2 col-form-label" },
                    [_vm._v(_vm._s(_vm.$t("loginPage.lgn")))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-7 col-sm-10" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.login,
                          expression: "login",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        placeholder: _vm.$t("loginPage.lgn"),
                        readonly: "",
                      },
                      domProps: { value: _vm.login },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.login = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-2 offset-md-9" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button-action firstButtonMarginTop",
                      attrs: { round: "", title: _vm.$t("common.negot") },
                      on: { click: _vm.changeAccountMember },
                    },
                    [
                      _c("i", { staticClass: "icon fa fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("history.SAVE")))]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toolbarPageBottomBlank" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }